import { addDismissedConnectionId } from './sessionDismissed.js'
import {
  dispatchConnectedToolkitsChanged,
  removeConnectedToolkitSlug,
} from './sessionToolkits.js'
import { toolkitConnectionRowId } from './inferSlug.js'
import {
  removePreviewAccountRowById,
  removePreviewAccountRowsForSlug,
} from './previewRowMutations.js'

export function disconnectToolkit({ toolkitSlug, accountId }) {
  const slug = String(toolkitSlug || '').trim().toLowerCase()
  if (!slug) return
  const id = String(accountId ?? '').trim()
  if (!id || id === toolkitConnectionRowId(slug)) {
    removeConnectedToolkitSlug(slug)
    removePreviewAccountRowsForSlug(slug)
    dispatchConnectedToolkitsChanged()
    return
  }
  addDismissedConnectionId(id)
  removePreviewAccountRowById(id)
}
